import React from "react";
import Footer from "./Footer";
import Header from "./Header";

const Layout = ({ page }) => (
  <>
    <Header />
        <main className="flex-grow-1">
          <div className="container h-100">
            <div className="row align-items-center h-100">
              <div className="col-md-8 mx-auto">
                {page}
              </div>
            </div>
          </div>
        </main>
    <Footer />
  </>
);

export default Layout;
